<template>
	<div>
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			controlltype: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: 'title',
				modal_width: 600,
				modal_height: 500,
				list_formConfig: [],
				list_columns: [
					{
						field: 'salercpt_no',
						title: '运单号',
					},
					{
						field: 'storage_name',
						title: '仓库',
					},
					{
						field: 'delivery_name',
						title: '快递',
					},
					{
						field: 'reason',
						title: '处理类型'
					},
					{
						field: 'staffid',
						title: '操作人',
						formatter: 'staff'
					},
					{
						field: 'create_time',
						title: '操作时间',
						formatter: 'datetime'

					}
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {
			if (this.list_autorender) {
				let controlltype = []
				for (let i in this.controlltype) {
					controlltype.push({
						label: this.controlltype[i],
						value: this.controlltype[i]
					})
				}
				this.list_formConfig = [{
					field: 'salercpt_no',
					title: '运单号',
					itemRender: {
						name: '$input'
					}
				}, {
					field: 'create_time',
					title: '操作时间',
					itemRender: {
						name: '$datePicker'
					}
				}, {
					field: 'reason',
					title: '处理类型',
					itemRender: {
						defaultValue: '拦截',
						name: '$select',
						props: {
							emptyoption: false,
							selectoptions: controlltype
						}
					}
				}]
				this.list_init()
			}
		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.pagerConfig.enabled = true
				gridOptions.height = 650
				//gridOptions.formConfig = false
			},
			list(page, updateForm, other) {
				return new Promise((reslove) => {
					this.$api.tradeerrornotice.list({
						type: 'expresshandle',
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						reslove(res)
					}, () => {
						reslove(false)
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>